<template>
  <div>
    <div v-ripple class="process" @click="openFolder(parentProcessObject)">
      <p class="ma-0">{{ parentProcess.toUpperCase() }}</p>
    </div>
    <div class="process-list">
      <div
        v-ripple
        v-for="process in filteredFolderProcesses"
        :key="process.name"
        class="process-item"
        :class="[fontSize,{highlight:(folder && folder.name===process.name)}]"

        @click="openFolder(process)"
      >
        <p v-if="xs">{{ topProcessesObject[process.name].xs ? topProcessesObject[process.name].xs : process.name }}</p>
        <p v-else-if="sm"> {{ topProcessesObject[process.name].sm ? topProcessesObject[process.name].sm : process.name }}</p>
        <p v-else-if="md"> {{ topProcessesObject[process.name].md ? topProcessesObject[process.name].md : process.name }}</p>
        <p v-else>{{ process.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import common from "@/mixins/common";
import {mapState} from "vuex";
export default {
  name: "MapTop",
  mixins: [common],
  data() {
    return  {
      parentProcess: 'Führungsprozesse',
      parentProcessObject: {},
      topProcesses: ['Strategische Planung', 'Zielsetzungsprozess', 'Controlling / Reporting / Finanzielle Führung', 'Kommunikation', 'Qualitätsmanagement', 'Mitarbeitenden-Führung'],
      topProcessesObject: {
        'Strategische Planung': 'Strategische Planung',
        'Zielsetzungsprozess': {xs: 'Ziel-setzungs-prozess', sm: 'Zielsetzungs-prozess'},
        'Controlling/ Reporting/ Finanzielle Führung': 'Controlling/ Reporting/ Finanzielle Führung',
        'Kommunikation': {xs: 'Kommuni-kation'},
        'Qualitätsmanagement': {xs: 'Qualitäts-management', md: 'Qualitäts-management'},
        'Mitarbeitenden-Führung': {xs: 'Mitarbeit-ende-Führung', sm: 'Mitarbeitenden-Führung'},
      },
      filteredFolderProcesses: [],
    }
  },
  computed: {
    ...mapState('documents', ['dataLoaded', 'documents', 'folders', 'foldersById']),
    fontSize() {
      if (this.xs) {
        return 'xsmall-font-size'
      } else if (this.xl) {
        return ''
      } else {
        return 'small-font-size'
      }
    },
    folderId(){
      return this.$route.params.folderId
    },
    folder(){
      return this.foldersById[this.folderId]
    }
  },
  methods: {
    computeFilteredFolderProcesses() {
      if (this.foldersById && Object.keys(this.foldersById).length > 0) {
        const topProcessesArray = Object.keys(this.topProcessesObject)
        this.filteredFolderProcesses = [];
        Object.keys(this.foldersById).forEach((key) => {
          const item = this.foldersById[key];
          const itemName = item.name.trim();
          if (topProcessesArray.includes(itemName)) {
            this.filteredFolderProcesses.push(item);
          } else if (itemName === this.parentProcess) {
            this.parentProcessObject = item;
          }
        });
      }
    },
    /**
     * A description of the entire function.
     *
     * @param {type} process - description of parameter
     * @return {type} description of return value
     */
    openFolder(process) {
      this.mx_isLeftDrawerOpen = true;
      this.$router.push({name: 'documentFolder', params: {instance: process.instance, folderId: process.id}});
    }
  },
  watch: {
    'foldersById': {
      immediate: true,
      handler(newValue) {
        this.computeFilteredFolderProcesses();
      }
    }
  },
}
</script>

<style scoped>
.process-list {
  display: flex;
  justify-content: space-between;
  gap: 2px;
  clip-path: polygon(50% 100%, 100% 75%, 100% 0, 0 0, 0 75%);
  width: 100%;
  height: 100px;
}

.process-item {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background-color: #b6d4ed;
  width: 100%;
  text-align: center;
  font-weight: bold;
}

.process-item p {
  margin: 1em 0;
  padding: 0 5px;
  color: #333333;
}

.xsmall-font-size p {
  font-size: x-small;
}

.small-font-size p {
  font-size: small;
}

.process {
  background-color: #b6d4ed;
  text-align: center;
  color: #333333;
  font-weight: bold;
  padding:2px 0;
  margin-bottom:2px
}
.highlight {
  background: none;
  background-color: #005289;

}
.highlight p{
  color:white
}
</style>